import {
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Switch,
} from "antd";
import toast from "react-hot-toast";
import { UpdateServiceDto } from "../../entities/dto/service.dto";
import { Service } from "../../entities/interfaces/service";
import ServiceService from "../../services/services.service";

type Props = {
  open: boolean;
  selected?: Service;
  onChange: () => void;
  onClose: () => void;
};

const ManageService = ({ open, onChange, selected, onClose }: Props) => {
  const [form] = Form.useForm<any>();
  const isCreate = !selected;
  const title = isCreate ? "Create Service" : "Update Service";
  const okButtonText = isCreate ? "Create" : "Update";
  if (!isCreate) {
    form.setFieldsValue(selected);
  }

  const handleSubmit = async (values: UpdateServiceDto) => {
    const res = isCreate
      ? await ServiceService.create(values)
      : await ServiceService.update(selected.id, values);

    if (res?.success) {
      isCreate
        ? toast.success("Service created")
        : toast.success("Service updated");
      onChange();
      closeModal();
    }
  };

  const closeModal = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={title}
      open={open}
      onOk={form.submit}
      onCancel={closeModal}
      centered
      okText={okButtonText}
      width={700}
    >
      <Form
        name="basic"
        form={form}
        initialValues={{ remember: true }}
        onFinish={handleSubmit}
        autoComplete="off"
        layout="vertical"
      >
        <Row gutter={20}>
          <Col flex={1}>
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please input name!" }]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item
              label="Price"
              name="price"
              rules={[{ required: true, message: "Please input price!" }]}
            >
              <InputNumber
                addonBefore="₹"
                autoComplete="off"
                className="w-full"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={20}>
          <Col span={12}>
            <Form.Item label="Image Url" name="imageUrl">
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Gender"
              name="gender"
              rules={[{ required: true, message: "Please input gender!" }]}
            >
              <Select>
                <Select.Option value="MALE">Male</Select.Option>
                <Select.Option value="FEMALE">Female</Select.Option>
                <Select.Option value="UNISEX">Unisex</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={20}>
          <Col flex={1}>
            <Form.Item
              label="Duration"
              name="duration"
              rules={[{ required: true, message: "Please input duration!" }]}
            >
              <InputNumber autoComplete="off" />
            </Form.Item>
          </Col>
          {!isCreate && (
            <Col flex={1}>
              <Form.Item label="Disable" name="disable">
                <Switch />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default ManageService;
